import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 136px 32px 32px 32px;
  min-width: 895px;
  width: 100%;
`;

export const Footer = styled.div`
  background-color: #ffffff;
  width: 100%;
  padding: 16px;
  margin-top: auto;
`;

export const Text = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;

export const Title = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props?.space}px;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props?.space}px;
`;

export const RowSpace: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: space-between;
`;

export const Body = styled.div`
  min-height: 450px;
  max-height: calc(100vh - 250px);
  flex: 1;
  overflow: auto;

  /* Estilização da scrollbar */
  &::-webkit-scrollbar {
    width: 0px; /* Largura da scrollbar */
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2); /* Cor da barra de rolagem */
    border-radius: 3px; /* Bordas arredondadas */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3); /* Cor ao passar o mouse */
  }

  &::-webkit-scrollbar-track {
    background: transparent; /* Fundo da track */
  }
`;

export const Card: any = styled.div`
  flex-shrink: 1;
  position: relative;
  border-radius: 9.843px;
  background: #fff;
  box-shadow: 0px 1.85px 9.24px 0px rgba(0, 0, 0, 0.1);
  padding: 16px 16px 0px 16px;
`;

export const SkeletonContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 8px;
`;
